if(typeof window.preload.node.crypto() === 'undefined') { var e = new Error("Cannot find module 'window.preload.node.crypto()'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = window.preload.node.crypto();